import { apiSlice} from "./ApiSlice";

const PharmacySaleApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        addNewPatient: builder.mutation({
            query: data => {
                return {
                    url: '/Sale-AddPatient',
                    method: 'POST',
                    body: data,
                }
            }
        }),
        searchPatient: builder.query({
            query: data => {
                return {
                    url: `/Sale-Getpatients?pharmaId=${data.pharmaId}&patientName=${data.patientName}`,
                    method: 'GET',
                }
            }
        }),
        addNewDoctor: builder.mutation({
            query: (data) => {
                return {
                    url: '/Sale-AddDoctor',
                    method: 'POST',
                    body: data,
                }
            }
        }),

        searchDoctor: builder.query({
            query: data => {
                return {
                    url: `/Sale-GetDoctors?pharmaId=${data.pharmaId}&doctorName=${data.doctorName}`,
                    method: 'GET',
                }
            }
        }),

        addSale: builder.mutation({
            query: (data) => {
                return {
                    url: '/Sale-AddSale',
                    method: 'POST',
                    body: data,
                }
            }
        }),
    })
})

export const { useAddNewPatientMutation, useAddNewDoctorMutation, useLazySearchPatientQuery, useLazySearchDoctorQuery, useAddSaleMutation } = PharmacySaleApiSlice;